import React from 'react';
import Box from '@mui/material/Box';

export default function Step({ children, sx = {}, fontSize = '1.05rem', fontWeight = 900, ...props }) {
    const style = {
        fontWeight,
        fontSize,
        ...sx,
    };
    return (
        <Box component="span" sx={style} {...props}>
            {children}
        </Box>
    );
}
